import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ROUTE_SEO, DEFAULT_SEO } from '@/config/seo'
import { applySeo } from '@/utils/applySeo'
import HomeView from '../views/HomeView.vue'
import cardVoucher from '../views/cardVoucher/index.vue'
import dynamics from '../views/dynamics/index.vue'
import cooperation from '../views/cooperation/index.vue'
import login from '../views/login/index.vue'
import personalCenter from '../views/personalCenter/index.vue'
import searchPage from '../views/searchPage/index.vue'
import official from '../views/official/index.vue'
import recovery from '../views/login/recovery.vue'
import aboutUs from '../views/aboutUs/index.vue'
import news from '../views/news/index.vue'
import newsDetail from '../views/newsDetail/index.vue'
import articleDetail from '../views/articleDetail/index.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { seoKey: 'home' },
  },
	{
	  path: '/cardVoucher',
	  name: 'cardVoucher',
	  component: cardVoucher,
		meta: { isAuth: true, seoKey: 'noindex' },
	},
	{
	  path: '/dynamics',
	  name: 'dynamics',
	  component: dynamics,
	  meta: { seoKey: 'dynamics' },
	},
	{
	  path: '/cooperation',
	  name: 'cooperation',
	  component: cooperation,
	  meta: { seoKey: 'cooperation' },
	},
	{
	  path: '/login',
	  name: 'login',
	  component: login,
	  meta: { seoKey: 'noindex' },
	},
	{
	  path: '/personalCenter',
	  name: 'personalCenter',
	  component: personalCenter,
		meta: { isAuth: true, seoKey: 'noindex' },
	},
	{
	  path: '/searchPage',
	  name: 'searchPage',
	  component: searchPage,
	  meta: { dynamicSeo: true },
	},
	{
	  path: '/official',
	  name: 'official',
	  component: official,
	  meta: { seoKey: 'official' },
	},
	{
	  path: '/recovery',
	  name: 'recovery',
	  component: recovery,
	  meta: { seoKey: 'noindex' },
	},
	{
	  path: '/aboutUs',
	  name: 'aboutUs',
	  component: aboutUs,
	  meta: { seoKey: 'aboutUs' },
	},
	{
	  path: '/news',
	  name: 'news',
	  component: news,
	  meta: { seoKey: 'news' },
	},
	{
	  path: '/newsDetail',
	  name: 'newsDetail',
	  component: newsDetail,
	  meta: { dynamicSeo: true },
	},
	{
	  path: '/articleDetail',
	  name: 'articleDetail',
	  component: articleDetail,
	  meta: { dynamicSeo: true },
	}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  // 判断是否需要鉴权
  if (to.meta.isAuth) {
    // 验证用户权限
		console.log(localStorage.getItem('londEssage'));
    if (localStorage.getItem('londEssage')) {
      next(); // 放行
    } else {
      alert('对不起，您还未登陆');
      next('/'); // 重定向到登录页面
    }
  } else {
    next(); // 不需要鉴权，直接放行
  }
});

router.afterEach((to) => {
  if (to.meta.dynamicSeo) {
    return
  }
  const seoKey = to.meta.seoKey as string | undefined
  const seoConfig = seoKey && ROUTE_SEO[seoKey] ? ROUTE_SEO[seoKey] : DEFAULT_SEO
  applySeo(seoConfig)
});

export default router
